import React from 'react';
import { Button, Text } from 'shared-components';

const TimeLineStep = ({ step, heading, text }: { step: string; heading: string; text: string }) => (
  <div className="grid grid-cols-1 grid-rows-[30px_min-content_1fr] gap-[10px]">
    <Button
      variant={'steps-current'}
      className="cursor-default border-none rounded-[1000px] !h-[30px] !w-[30px] p-[0px] !max-h-[30px] !max-w-[30px] text-[16px] leading-[110%] font-condensed mx-auto"
    >
      {step}
    </Button>
    {heading && (
      <Text variant="subheadline-sm2" className="!text-[16px] !font-extended !leading-[120%]">
        {heading}
      </Text>
    )}
    {text && (
      <Text variant="body-form-label" className="!text-[16px] !font-standard !leading-[120%]">
        {text}
      </Text>
    )}
  </div>
);

export const EQFlowFooter = () => {
  return (
    <>
      <div className={'!h-[1px] !min-h-[1px] !max-w-[592px] mx-auto !w-full bg-dawn2'} />
      <div className="w-full grid grid-cols-1 !max-w-[592px] mx-auto gap-[40px] my-[40px]">
        <Text variant="subheadline-sm2" className="!text-[32px] !font-standard !leading-[110%]">
          Why Finance with Tento
        </Text>
        <div className="grid grid-cols-1 w768:grid-cols-3 gap-[20px]">
          <TimeLineStep step="01" heading="Lightning-Fast Decisions" text="Get pre-qualified in minutes, not days." />
          <TimeLineStep
            step="02"
            heading="Terms on your Side"
            text="Interest-free for 30 days. No payments due for 90 days"
          />
          <TimeLineStep
            step="03"
            heading="Concierge-Style Support"
            text="Work with one dedicated financing specialist."
          />
        </div>
      </div>
    </>
  );
};
